import {combineReducers} from 'redux';
import constantsAll from '../../../data/constants';
import {checkTypes} from '../../technique/utils';

const nextState = (oldState, payload) => ({
  ...oldState,
  ...payload,
});

const generateReducer =
  (constants, initialState) =>
  (state = initialState, action) => {
    if (checkTypes(action.type, constants)) {
      return nextState(state, action.payload);
    }
    return state;
  };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const customReducers = {
  user: (state = {}, action) => {
    switch (action.type) {
      case 'UPDATE_USER':
        return {...state, ...action.payload};
      case 'LOGOUT':
        return {};
      default:
        return state;
    }
  },
};

export const reducersAll = () => {
  if (!constantsAll) {
    return {};
  }
  return constantsAll.reduce((acc, curr) => {
    const {constants, entity, initialState} = curr;
    return {
      ...acc,
      [entity]: generateReducer(constants, initialState),
    };
  }, {});
};

const combinedReducers = () => {
  const dynamicReducers = reducersAll(); // Récupérer tous les reducers générés dynamiquement

  // Parcourir toutes les clés de customReducers pour combiner les reducers dynamiques et spécifiques
  const combined = Object.keys(customReducers).reduce((acc, key) => {
    acc[key] = (state = {}, action) => {
      const dynamicReducer = dynamicReducers[key]; // Récupérer le reducer dynamique pour la clé
      const customReducer = customReducers[key]; // Récupérer le reducer spécifique pour la clé

      // Appliquer d'abord le reducer dynamique, puis le reducer spécifique
      const intermediateState = dynamicReducer
        ? dynamicReducer(state, action)
        : state;
      return customReducer(intermediateState, action);
    };
    return acc;
  }, {});

  // Ajouter les reducers dynamiques qui ne sont pas dans customReducers
  Object.keys(dynamicReducers).forEach(key => {
    if (!combined[key]) {
      combined[key] = dynamicReducers[key];
    }
  });

  return combined;
};

export default combineReducers(combinedReducers());
